import { render, staticRenderFns } from "./TradeMaster.vue?vue&type=template&id=54b59660"
import script from "./TradeMaster.vue?vue&type=script&lang=js"
export * from "./TradeMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports